// Maps the Mobile App's Ionicons names to lucide-react icons for the Web.
import {
  Copy,
  Paperclip,
  Eye,
  EyeOff,
  Maximize2,
  AlertTriangle,
  Bookmark,
  WifiOff,
  MoreHorizontal,
  GripVertical,
  Mail,
  MessageSquareText,
  Link2,
  HelpCircle,
  XCircle,
  Sparkle,
  Search,
  Mic,
  Play,
  Pause,
  Calendar,
  Clock,
  MapPin,
  Music,
  Music2,
  List,
  ListMusic,
  ChevronRight,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  SkipBack,
  SkipForward,
  Repeat,
  X,
  Volume2,
  Star,
  CloudOff,
  AlertCircle,
  Home,
  Library,
  MessageCircle,
  User,
  Users,
  Settings,
  LogOut,
  Bell,
  CheckCircle2,
  Circle,
  Image as ImageIcon,
  FileText,
  Download,
  Plus,
  Trash2,
  Pencil,
  Upload,
  CalendarCheck,
  ClipboardList,
  KeyRound,
  Send,
  Megaphone,
  BarChart3,
  Piano,
  Sparkles,
  Languages,
  Lightbulb, Repeat1, Shuffle, Share2, ArrowUp, ArrowDown } from "lucide-react";

const MAP = {
  search: Search,
  "search-outline": Search,
  mic: Mic,
  play: Play,
  pause: Pause,
  "play-back": SkipBack,
  "play-forward": SkipForward,
  repeat: Repeat,
  "repeat-one": Repeat1,
  shuffle: Shuffle,
  share: Share2,
  "arrow-up": ArrowUp,
  "arrow-down": ArrowDown,
  close: X,
  "volume-high": Volume2,
  star: Star,
  "star-outline": Star,
  "calendar-outline": Calendar,
  calendar: Calendar,
  "time-outline": Clock,
  "location-outline": MapPin,
  "musical-notes-outline": Music2,
  "musical-notes": Music2,
  "musical-note-outline": Music,
  list: List,
  "list-music": ListMusic,
  "chevron-forward": ChevronRight,
  "chevron-down": ChevronDown,
  "chevron-up": ChevronUp,
  "chevron-back": ChevronLeft,
  "cloud-offline-outline": CloudOff,
  "alert-circle-outline": AlertCircle,
  home: Home,
  library: Library,
  "chatbubbles-outline": MessageCircle,
  chatbubble: MessageCircle,
  person: User,
  "person-outline": User,
  people: Users,
  settings: Settings,
  logout: LogOut,
  bell: Bell,
  checkmark: CheckCircle2,
  circle: Circle,
  image: ImageIcon,
  document: FileText,
  "document-text": FileText,
  download: Download,
  add: Plus,
  trash: Trash2,
  pencil: Pencil,
  upload: Upload,
  "calendar-check": CalendarCheck,
  clipboard: ClipboardList,
  key: KeyRound,
  send: Send,
  megaphone: Megaphone,
  stats: BarChart3,
  piano: Piano,
  sparkles: Sparkles,
  language: Languages,
  bulb: Lightbulb,
  ellipsis: MoreHorizontal,
  "bookmark-outline": Bookmark,
  offline: WifiOff,
  warning: AlertTriangle,
  expand: Maximize2,
  copy: Copy,
  attach: Paperclip,
  eye: Eye,
  "eye-off": EyeOff,
  grip: GripVertical,
  mail: Mail,
  sms: MessageSquareText,
  link: Link2,
  help: HelpCircle,
  "close-circle": XCircle,
  new: Sparkle,
};

export function Icon({ name, size = 18, color = "currentColor", strokeWidth = 2, className, style }) {
  const Cmp = MAP[name] || Circle;
  return <Cmp size={size} color={color} strokeWidth={strokeWidth} className={className} style={style} />;
}
